// hooks/useSEO.js - versión extendida
import { useEffect } from "react";

export const useSEO = ({
  title,
  description,
  keywords = "",
  image = "/og-default.jpg",
  type = "website",
  canonicalUrl = null,
}) => {
  useEffect(() => {
    // Title
    const fullTitle = title
      ? `${title} | Venta Usados Tattersall`
      : "Venta Usados Tattersall";
    document.title = fullTitle;

    // Description
    setMetaTag("name", "description", description);

    // Keywords
    if (keywords) {
      setMetaTag("name", "keywords", keywords);
    }

    // Canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalUrl || window.location.href.split("?")[0];

    // Open Graph para redes sociales
    setMetaTag("property", "og:title", fullTitle);
    setMetaTag("property", "og:description", description);
    setMetaTag(
      "property",
      "og:image",
      `https://tattersallventausados.cl${image}`
    );
    setMetaTag("property", "og:url", window.location.href);
    setMetaTag("property", "og:type", type);
    setMetaTag("property", "og:site_name", "Tattersall Venta Usados");
    setMetaTag("property", "og:locale", "es_CL");

    // Twitter Cards
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", fullTitle);
    setMetaTag("name", "twitter:description", description);
    setMetaTag(
      "name",
      "twitter:image",
      `https://tattersallventausados.cl${image}`
    );
  }, [title, description, keywords, image, type, canonicalUrl]);
};

// Función helper
const setMetaTag = (attribute, value, content) => {
  let meta = document.querySelector(`meta[${attribute}="${value}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attribute, value);
    document.head.appendChild(meta);
  }
  meta.content = content;
};
